module.exports = __webpack_public_path__ + "1_0_64/img/mobile.107fef4f.webp";